import React, { useState } from 'react';

//Custo css import
import './style.css';

//Boostrap import
import Form from 'react-bootstrap/Form';

//Controller import (placeholder for password reset use case)
// import { resetPassword } from '../../../usecases/auth-usecase'; // Assuming an auth-usecase exists or will be created
import ButtonLoading from '../../atoms/buttonLoading/view';
import easypos from '../../../assets/images/easypos.svg';
import { recoveryPassword } from '../../../usecases/users-usecases'

function ForgotPassword() {

    const [formData, setFormData] = useState(
        {
            email: ''
        }
    );
    const [loading, setLoading] = useState(false); // State for loading button

    function handleChange(event) {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
    }

    async function handleResetPassword() {
        setLoading(true);
        recoveryPassword(formData).then(() => {
            window.location.replace('/login');
        }).catch(() => {
            window.location.replace('/login');
        })
    }

    return (
        <div className='forgot-password-container'>
            <div className="forgot-password-card">
                <div className="forgot-password-logo">
                    <img src={easypos} alt="Easypos Logo" className='brand' />
                </div>
                <div className="forgot-password-description">
                    Introduce tu correo electrónico para restablecer tu contraseña.
                </div>
                <Form
                    className="forgot-password-form"
                    id="forgot-password-form"
                    action="javascript:void(0);"
                    onSubmit={handleResetPassword}
                >
                    <Form.Group className="mb-3" id="formBasicEmail">
                        <Form.Label>Correo electrónico</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder="Escriba su correo"
                            name="email"
                            onChange={handleChange}
                            value={formData.email}
                        />
                    </Form.Group>
                    <ButtonLoading
                        id="reset-password"
                        className="forgot-password-btn"
                        variant="primary"
                        title="Restablecer"
                        showLoading={loading}
                        onClick={handleResetPassword}
                        disabled={!formData.email.trim()}
                    />
                </Form>
                <button className="forgot-password-login-link" onClick={() => window.location.replace('/login')}>
                    Volver al inicio de sesión
                </button>
            </div>
        </div>
    )

}

export default ForgotPassword
